import { formatISO, parseISO } from 'date-fns'
import { Draft } from 'immer'
import { computeDurationFromDates } from '@opallabs/lambda'
import { BlockResponse } from '../types'

type UpdateBlockDetailsParams = {
  templateDescription?: string | null
  templateName?: string | null
  title?: string
  startDate?: Date | null
  endDate?: Date | null
  description?: string | null
  color?: string | null
  blockCategoryData?: BlockResponse['data']['details']['category']
}

export const updateBlockDetails = (params: UpdateBlockDetailsParams) => {
  return (draftDocument: Draft<BlockResponse>) => {
    if (!draftDocument.data) return draftDocument

    const block = draftDocument.data

    if (params.title !== undefined) {
      block.title = params.title
    }
    if (params.startDate !== undefined) {
      block.start_date = params.startDate
        ? formatISO(params.startDate, { representation: 'date' })
        : null
    }
    if (params.endDate !== undefined) {
      if (params.endDate === null) {
        block.duration = null
      } else {
        const startDate =
          params.startDate ??
          (block.start_date ? parseISO(block.start_date) : null)
        block.duration = startDate
          ? computeDurationFromDates(startDate, params.endDate)
          : null
      }
    }
    if (params.description !== undefined) {
      block.details.description = params.description
    }
    if (params.templateDescription !== undefined) {
      block.template_description = params.templateDescription
    }
    if (params.templateName !== undefined) {
      block.template_name = params.templateName
    }
    if (params.color !== undefined) {
      block.details.color = params.color
    }
    if (params.blockCategoryData) {
      block.details.category = params.blockCategoryData
    }

    return draftDocument
  }
}
